'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { Container, FilledStars, StarOutlines } from './styles';
const DEFAULT_STAR_SIZE = '17.5px';
export const Template = ({ starSize = DEFAULT_STAR_SIZE, rating, ...rest }) => {
    return (_jsxs(Container, { "$starSize": starSize, ...rest, children: [_jsx(StarOutlines, {}), _jsx(FilledStars, { rating: Math.min(5, rating) }), _jsx(ScreenReaderOnly, { children: rating })] }));
};
//# sourceMappingURL=Template.js.map